import Point from '../../Utility/Point';
import UIComponent from './UIComponent';
import Element from '../../Prototype/UI/Element';
import * as PIXI from 'pixi.js';
import 'lib/pixi-ui/pixi-ui';
import Game from '../../Game';
import TextStyleOptions = PIXI.TextStyleOptions;
import { LanguageKey } from '../../Utility/SDK/Language';

const MIN_FONT_SIZE = 8;

export default class UITextComponent extends UIComponent {
    public UIComponent: PIXI.ui.component.Text;
    private _bounds: Point;
    private shouldRecalculateSize: boolean;

    public attach(gameObject: Element, params: any): void {
        let text: string;

        this.shouldRecalculateSize = true;

        if (params.data.textLocalizationKey) {
            try {
                text = Game.locale.getText(params.data.textLocalizationKey);
            } catch {
                text = params.data.textLocalizationKey;
            }
        } else if (params.data.textUnlocalized) {
            text = params.data.textUnlocalized;
        }

        const style: any = params.data.style;
        if (style.style) style.fontStyle = style.style;

        style.fontSize = Math.max(
            parseInt(style.fontSize as string),
            MIN_FONT_SIZE
        );
        if(Game.sdk.getLanguage() === LanguageKey.JAPANESE_JA){
            style.fontFamily = "Corp";
            style.fontSize = Math.max(
                parseInt(style.fontSize as string),
                MIN_FONT_SIZE
            );
            style.fontWeight = "bold";
        }
        else if (style.font) style.fontFamily = style.font;

        

        delete style.style;
        delete style.font;

        this.UIComponent = new PIXI.ui.component.Text(text, {
            ...style,
            align: params.data.align,
            wordWrap: params.data.wordWrap,
            wordWrapWidth: params.data.wordWrapWidth,
        });

        gameObject.container.add(this.UIComponent);

        if (params.data.bounds) {
            this.bounds = new Point(
                params.data.bounds[0],
                params.data.bounds[1]
            );
        }

        super.attach(gameObject, params);
    }

    get text(): string {
        return this.UIComponent.text;
    }

    set text(value: string) {
        this.shouldRecalculateSize =
            this.shouldRecalculateSize ||
            // If text length was changed should resize.
            (this.text && this.text.length !== value.length) ||
            // If align is right should resize because some styles don't respect that.
            this.style.align === 'right';

        this.UIComponent.text = value;

        if (this.shouldRecalculateSize) {
            this.recalculateSize();
            this.shouldRecalculateSize = false;
        }
    }

    get style(): TextStyleOptions {
        return this.UIComponent.PIXIText.style;
    }

    set style(style: TextStyleOptions) {
        this.UIComponent.textStyleOptions = style;
        this.recalculateSize();
    }

    set bounds(value: Point) {
        // Validate.
        if (!value || value.x <= 0 || value.y <= 0) return;

        this._bounds = value;

        this.recalculateBounds();
    }

    get bounds() {
        return this._bounds;
    }

    public recalculateBounds(text?: string): void {
        if (!text) text = this.UIComponent.PIXIText.text;

        // Try until get a fitable fontSize.
        for (
            let fontSize =
                parseInt(this.UIComponent.PIXIText.style.fontSize as string) -
                1;
            fontSize > MIN_FONT_SIZE;
            fontSize--
        ) {
            const metrics = PIXI.TextMetrics.measureText(
                text,
                this.UIComponent.PIXIText.style,
                this.UIComponent.PIXIText.style.wordWrap
            );
            if (
                metrics.width > this._bounds.x ||
                metrics.height > this._bounds.y
            ) {
                this.UIComponent.PIXIText.style.fontSize = fontSize;
            } else {
                break;
            }
        }
    }

    public recalculateSize(): void {
        this.container.desiredWidth = this.UIComponent.PIXIText.width;
        this.container.desiredHeight = this.UIComponent.PIXIText.height;
        this.container.resize(0, 0);
    }
}
